import { Injectable } from "@angular/core"
import { AngularFirestoreCollection, AngularFirestoreDocument } from "@angular/fire/firestore"
import { ClaimedTest } from "@tr/models"
import { getDataItem } from "@tr/utils"
import { FirebaseCollectionBase } from "./firebase-resource-base"
import { FirebaseService } from "./firebase.service"

@Injectable({
  providedIn: "root",
})
export class ClaimedTestsService extends FirebaseCollectionBase<ClaimedTest> {
  public getId = (item: ClaimedTest) => [
    item.company,
    item.runId,
    item.testId,
    item.claimedId,
  ].join("-")

  constructor(fb: FirebaseService) {
    super(fb)
  }

  public async getClaimedTest(id: string, internal: boolean, company: string, uid: string): Promise<ClaimedTest> {
    return getDataItem<ClaimedTest>(
      this.getClaimedTests(internal, company, uid).doc(id),
    )
  }

  public getClaimedTests(internal: boolean, company: string, uid: string): AngularFirestoreCollection<ClaimedTest> {
    return this.getUserDocument(internal, company, uid)
      .collection<ClaimedTest>("ClaimedTests")
  }

  public async deleteClaimedTest(internal: boolean, uid: string, claimedTest: ClaimedTest): Promise<void> {
    return this.getClaimedTests(internal, claimedTest.company, uid)
      .doc(this.getId(claimedTest))
      .ref.delete()
  }

  public getUserDocument(internal: boolean, company: string, uid: string): AngularFirestoreDocument {
    let claimedTestsParentCollection: AngularFirestoreCollection
    if (internal) {
      claimedTestsParentCollection = this.firebaseService.companyUsersCollection(company)
    } else {
      claimedTestsParentCollection = this.firebaseService.collection("Seva Testers")
    }

    return claimedTestsParentCollection
      .doc(uid)
  }

  public async getData(internal: boolean, company: string, uid: string, project: string): Promise<ClaimedTest[]> {
    const claimedTestCollection = this.getClaimedTests(internal, company, uid)
    const claimedTestRef = internal
      ? claimedTestCollection.ref.where("project", "==", project)
      : claimedTestCollection.ref

    const claimedTestsSnapshot = await claimedTestRef.get()
    this.data = claimedTestsSnapshot.docs.map<any>(doc => {
      const claimedTest = {
        id: doc.id,
        // TODO: Use _id, but keep id until all uses are removed...
        _id: doc.id,
        ...doc.data(),
      } as ClaimedTest
      this.dataMap[doc.id] = claimedTest
      return claimedTest
    })

    return this.data
  }
}
